import module from 'nominas/nomina/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

export class NominaConfiguracionDescuentosComponent {
  idProyecto
  idNomina
  actualizando = false
  error = null
  modificado = false

  constructor ($q, $state, NominasNominaStatus, NominasNominaConfiguracionColaboradoresDescuentosConceptos) {
    this.$q = $q
    this.$state = $state
    this.NominasNominaStatus = NominasNominaStatus
    this.NominasNominaConfiguracionColaboradoresDescuentosConceptos = NominasNominaConfiguracionColaboradoresDescuentosConceptos
  }

  $onInit () {
    this.promise = this.$q.all([
      this.NominasNominaStatus.get(this.idProyecto, this.idNomina)
        .then(({data}) => (this.editable = !data.status_calculado)),
      this.NominasNominaConfiguracionColaboradoresDescuentosConceptos.get(this.idProyecto, this.idNomina)
        .then(({data}) => (this.data = orderBy(data, ['descripcion']))),
    ])
  }

  actualizar () {
    if (!this.modificado) {
      return cerrar()
    }

    if (this.actualizando) return

    this.actualizando = true
    this.error = null

    this.NominasNominaConfiguracionColaboradoresDescuentosConceptos.put(this.idProyecto, this.idNomina, this.data)
      .then(() => (this.cerrar()))
      .catch(({data}) => (this.error = data))
      .finally(() => (this.actualizando = false))
  }

  cerrar () {
    this.$state.go('nominas.detalladoNomina.colaboradores.descuentos')
  }

  seleccionar (item) {
    if (this.actualizando) return

    item.activo = !item.activo
    this.modificado = true
  }
}

module.component('nominasNominaConfiguracionDescuentos', {
  controller: NominaConfiguracionDescuentosComponent,
  template,
  bindings: {
    idProyecto: '<',
    idNomina: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/configuracion/descuentos/component.js